import React from 'react';

const DropdownList = ({id, name, list, onChange, value}) => {
  return (
    <select
      id={id}
      name={name}
      style={{backgroundColor: "white", fontSize: "20px", outline: "solid rgba(202, 204, 207, 1) 1px"}}
      className="bg-white text-xs w-80 h-12 cursor-pointer rounded-md px-3"
      placeholder='Select Data'
      onChange={onChange}
      value={value}
    >
      {list ?
        list.map((item, index) => {
          return (
            <option key={index} value={item.value}> {item.label} </option>
          )
        }) :
        'No Data'
      }
    </select>
  );
};

export default DropdownList;